import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import './SocialButtonsList.scss';
import SocialButtonsList from './SocialButtonsList';
import { useNotNullableContext } from '../../hooks/useNotNullableContext';
import { PageMetaContext } from '../../context/PageMetaContext';
import { filterByTypename } from '../../utils/graphql';
import generateHash from '../../utils/generateHash';
import { useIsMounted } from '../../hooks/useIsMounted';
import useBasePageQuery from '../../hooks/useBasePageQuery';

export type SocialButtonsListWrapperProps = {
  message?: string;
  subject?: string;
};

const SocialButtonsListWrapper: FunctionComponent<SocialButtonsListWrapperProps> = ({
  message,
  subject,
}) => {
  const result = useBasePageQuery();
  const isMounted = useIsMounted();
  const { pageType, pageShortName, currentUrl } = useNotNullableContext(
    PageMetaContext,
  );
  const { t } = useTranslation('common', { useSuspense: false });

  if (!isMounted || !result.data?.page) {
    return null;
  }

  const { relationships, title } = result.data.page;
  const beneficiaries = relationships?.beneficiaries;
  const charities = filterByTypename(beneficiaries?.nodes ?? [], 'Charity');

  const firstCharityName = charities[0]?.name
    ? charities[0].name
    : t('charity.defaultName');

  const defaultMessage = `${message ||
    t('common.shareMessageGeneric', { charityName: firstCharityName })}`;
  const giftAidMessage = t('common.charityGiftAid', {
    charityName: firstCharityName,
    count: (beneficiaries && beneficiaries.totalCount) || 0,
  });

  return (
    <SocialButtonsList
      subject={subject || title || t('common.defaultEmailSubject')}
      messages={{
        default: defaultMessage,
        email: `${t('common.greeting')},\n\n${message ||
          defaultMessage} ${`${currentUrl}?utm_source=Sharethis&utm_medium=${pageType}&utm_content=${pageShortName}&utm_campaign=pfp-email&utm_term=${generateHash()}`}\n\n${giftAidMessage}\n\n${t(
          'common.emailThanks',
        )}`,
      }}
    />
  );
};

export default SocialButtonsListWrapper;
